import { render, staticRenderFns } from "./bookSummary.vue?vue&type=template&id=c77f70e6&"
import script from "./bookSummary.vue?vue&type=script&lang=js&"
export * from "./bookSummary.vue?vue&type=script&lang=js&"
import style0 from "./bookSummary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports